import React, { useEffect, useState } from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid"; // optional for list icons

const TermsAndConditions = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const sections = [
    {
      title: "1️⃣ প্ল্যাটফর্ম ব্যবহারের শর্ত",
      items: [
        "Super Store ব্যবহার করতে আপনার বয়স কমপক্ষে ১৮ বছর হতে হবে।",
        "আপনাকে সঠিক ও সত্য তথ্য প্রদান করতে হবে।",
        "কোনো ধরনের অপব্যবহার, প্রতারণা বা নীতিমালা ভঙ্গ করলে Super Store আপনার অ্যাকাউন্ট স্থগিত বা বন্ধ করতে পারে।",
      ],
    },
    {
      title: "2️⃣ মার্কেটপ্লেসে ভূমিকা",
      items: [
        "Super Store ক্রেতা ও বিক্রেতার মধ্যে সংযোগ স্থাপন করে।",
        "পণ্যের সঠিক তথ্য, মান ও ডেলিভারির দায়িত্ব সম্পূর্ণভাবে বিক্রেতার।",
        "বিশেষভাবে উল্লেখ না থাকলে Super Store নিজে কোনো পণ্যের বিক্রেতা নয়।",
      ],
    },
    {
      title: "3️⃣ অর্ডার ও পেমেন্ট",
      items: [
        "অনলাইন পেমেন্ট বা ক্যাশ অন ডেলিভারি (COD) নিশ্চিত হওয়ার পর অর্ডার কনফার্ম করা হয়।",
        "উল্লেখ না থাকলে পণ্যের দামের সাথে প্রযোজ্য ট্যাক্স অন্তর্ভুক্ত থাকে।",
        "ডেলিভারি সময়: ঢাকা: ১ দিন, ঢাকার বাইরে: ২–৩ দিন।",
      ],
    },
    {
      title: "4️⃣ রিটার্ন ও রিফান্ড",
      items: [
        "রিটার্ন আমাদের রিটার্ন ও রিফান্ড নীতিমালা অনুযায়ী প্রযোজ্য।",
        "রিফান্ড সাধারণত ৭–১০ কার্যদিবসের মধ্যে সম্পন্ন হয়।",
      ],
    },
    {
      title: "5️⃣ Intellectual Property",
      items: [
        "Super Store-এর লোগো, UI ও ব্র্যান্ডিং সম্পূর্ণভাবে Super Store-এর মালিকানাধীন।",
        "বিক্রেতারা তাদের পণ্যের কনটেন্টের মালিকানা বজায় রাখবেন, তবে Super Store-কে তা প্রদর্শনের অনুমতি দেবেন।",
      ],
    },
    {
      title: "6️⃣ Limitation of Liability",
      items: [
        "তৃতীয় পক্ষের বিক্রেতার কোনো সমস্যার জন্য Super Store দায়ী নয়।",
        "Super Store-এর দায়বদ্ধতা সর্বোচ্চ পণ্যের ক্রয়মূল্যের মধ্যে সীমাবদ্ধ।",
      ],
    },
    {
      title: "7️⃣ Governing Law",
      items: ["এই শর্তাবলি বাংলাদেশের প্রচলিত আইন 🇧🇩 অনুযায়ী পরিচালিত হবে।"],
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-r from-gray-100 to-slate-200 flex justify-center px-4 py-10 select-none">
      <div className="w-full max-w-3xl space-y-6">
        <h1 className="text-center text-3xl font-bold text-indigo-600 mb-8">
          📜 Terms & Conditions – Super Store
        </h1>

        {sections.map((section, idx) => (
          <div
            key={idx}
            className="bg-white rounded-xl shadow-md p-6 hover:shadow-xl transition-shadow duration-300"
          >
            <h3 className="text-xl font-semibold text-indigo-600 mb-4 border-b pb-2">
              {section.title}
            </h3>
            <ul className="space-y-3">
              {section.items.map((item, i) => (
                <li
                  key={i}
                  className="flex items-start gap-2 bg-indigo-50 rounded-lg p-3 text-gray-700 hover:bg-indigo-100 transition-colors"
                >
                  <CheckCircleIcon className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="
              fixed bottom-6 right-6
              w-8 h-8 md:w-8 md:h-8
              bg-darkBgColor text-white
              rounded-full
              shadow-lg
              flex items-center justify-center
            "
        >
          ↑
        </button>
      )}
    </div>
  );
};

export default TermsAndConditions;
